// extracted by mini-css-extract-plugin
module.exports = {"link":"NOHEfficiencyTile_link__1ag6N","arrow":"NOHEfficiencyTile_arrow__vB6vw","tileTitle":"NOHEfficiencyTile_tileTitle__9f8RT"};